import PageContainer from '@/common/components/PageContainer'
import { useTablePagination } from '@/common/hooks/useTablePaginate'

import useQueryGetCryptoInvoices from '../../api/hooks/useQueryGetCryptoInvoices'
import BillingDetailsSummary from '../../components/BillingDetailsSummary'
import CryptoInvoicesListing from '../../components/CryptoInvoicesListing'

function CryptoInvoicesPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()

	// Fetch crypto invoices
	const invoicesPayload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		txId: searchQuery || undefined,
	}
	const { data: invoicesData, isLoading: isInvoicesLoading } =
		useQueryGetCryptoInvoices(invoicesPayload)

	return (
		<PageContainer>
			<div className="space-y-6">
				<CryptoInvoicesListing
					data={invoicesData?.data || []}
					total={invoicesData?.total || 0}
					isLoading={isInvoicesLoading}
				/>
				<BillingDetailsSummary />
			</div>
		</PageContainer>
	)
}

export default CryptoInvoicesPage
